// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__1p2Dn","subheader":"ReorderModal_subheader__3_hd6","listWrap":"ReorderModal_listWrap__2c8YV"};